import { Box, Typography } from "@mui/material";

export function EPSDefinition() {
	return (
		<Box
			sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}
		>
			<Typography variant='body1'>Gestão de Acesso</Typography>
		</Box>
	);
}
